import React from 'react';
import PropTypes from 'prop-types';
import CoinStat from 'modules/stats/coinStat.component';
import RStat from 'modules/stats/rStat.component';
import Percent from 'modules/stats/percent.component';
import { Text } from 'modules/styled';

ProfileStats.propTypes = {
  user: PropTypes.object,
  isOwner: PropTypes.bool,
};

export default function ProfileStats({ user, isOwner }) {
  return (
    <Text sx={{ lineHeight: 21 }}>
      <RStat noSpace pr={1.5} inline={1} user={user} />
      {'  '}
      <Percent size={1.5 * 8} user={user} />
      {'   '}
      <CoinStat noSpace inline={1} user={user} isOwner={isOwner} />
    </Text>
  );
}
